import { useEffect, useState } from 'react';

export default function CombinedRippleEffect() {
  const [currentEffect, setCurrentEffect] = useState(0);

  useEffect(() => {
    const effects = [

      (x, y) => {
        const spawnRipple = (x, y, delay = 0) => {
          const ripple = document.createElement('div');
          ripple.className = 'ripple-effect-2';
          ripple.style.left = `${x - 15}px`;
          ripple.style.top = `${y - 15}px`;
          ripple.style.animationDelay = `${delay}ms`;

          const container = document.getElementById('ripple-container');
          if (container) { container.appendChild(ripple); }

          ripple.addEventListener('animationend', () => ripple.remove());
        };

        for (let i = 0; i < 3; i++) {
          spawnRipple(x, y, i * 200);
        }
      },

      (x, y) => {
        const ripple = document.createElement('div');
        ripple.className = 'ripple-effect-3';
        ripple.style.left = `${x - 100}px`;
        ripple.style.top = `${y - 100}px`;

        const container = document.getElementById('ripple-container');
        if (container) { container.appendChild(ripple); }

        ripple.addEventListener('animationend', () => ripple.remove());
      },

      (x, y) => {
        const ripple = document.createElement('div');
        ripple.className = 'ripple-effect-4';
        ripple.style.left = `${x - 50}px`;
        ripple.style.top = `${y - 50}px`;

        const container = document.getElementById('ripple-container');
        if (container) { container.appendChild(ripple); }

        ripple.addEventListener('animationend', () => ripple.remove());
      },

      (x, y) => {
        const spawnRipple = (x, y, lightness) => {
          const ripple = document.createElement('div');
          ripple.className = 'ripple-effect-5';
          ripple.style.left = `${x - 10}px`;
          ripple.style.top = `${y - 10}px`;
          ripple.style.background = `hsl(0, 0%, ${lightness}%)`;
          ripple.style.opacity = '1';

          const container = document.getElementById('ripple-container');
          if (container) { container.appendChild(ripple); }

          ripple.addEventListener('animationend', () => ripple.remove());
        };

        const totalRipples = 5;
        const spacing = 1000 / totalRipples;

        for (let i = 0; i < totalRipples; i++) {
          const t = i / totalRipples;
          const waveValue = (Math.sin(t * Math.PI * 2) + 1) / 2;
          const lightness = 70 + waveValue * 25;

          setTimeout(() => spawnRipple(x, y, lightness), i * spacing);
        }
      },

      (x, y) => {
        const spawnRipple = (x, y, lightness, offset) => {
          const ripple = document.createElement('div');
          ripple.className = 'ripple-effect-6';
          ripple.style.left = `${x + offset.dx - 10}px`;
          ripple.style.top = `${y + offset.dy - 10}px`;
          ripple.style.background = `hsl(0, 0%, ${lightness}%)`;
          ripple.style.opacity = '1';

          const container = document.getElementById('ripple-container');
          if (container) { container.appendChild(ripple); }

          ripple.addEventListener('animationend', () => ripple.remove());
        };

        const totalRipples = 6;
        const spacing = 1000 / totalRipples;

        for (let i = 0; i < totalRipples; i++) {
          const t = i / totalRipples;
          const waveValue = (Math.sin(t * Math.PI * 2) + 1) / 2;
          const lightness = 70 + waveValue * 25;

          const radius = 20 + waveValue * 30;
          const angle = t * Math.PI * 2;
          const dx = Math.cos(angle) * radius;
          const dy = Math.sin(angle) * radius;

          setTimeout(() => spawnRipple(x, y, lightness, { dx, dy }), i * spacing);
        }
      },

      (x, y) => {
        const spawnRipple = (x, y, hue, size, offset) => {
          const ripple = document.createElement('div');
          ripple.className = 'ripple-effect-7';
          ripple.style.left = `${x + offset.dx - size / 2}px`;
          ripple.style.top = `${y + offset.dy - size / 2}px`;
          ripple.style.width = `${size}px`;
          ripple.style.height = `${size}px`;
          ripple.style.background = `hsl(${hue}, 40%, 80%)`;
          ripple.style.opacity = '1';

          const container = document.getElementById('ripple-container');
          if (container) { container.appendChild(ripple); }

          ripple.addEventListener('animationend', () => ripple.remove());
        };

        const totalRipples = 7;
        const spacing = 1000 / totalRipples;

        for (let i = 0; i < totalRipples; i++) {
          const t = i / totalRipples;
          const waveValue = (Math.sin(t * Math.PI * 2) + 1) / 2;

          const hue = 180 + waveValue * 60;
          const size = 15 + waveValue * 25;

          const radius = 20 + waveValue * 40;
          const angle = t * Math.PI * 2;
          const dx = Math.cos(angle) * radius;
          const dy = Math.sin(angle) * radius;

          setTimeout(() => spawnRipple(x, y, hue, size, { dx, dy }), i * spacing);
        }
      }
    ];

    const handleClick = (e) => {
      const x = e.pageX;
      const y = e.pageY;

      effects[currentEffect](x, y);

      setCurrentEffect((prev) => (prev + 1) % effects.length);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [currentEffect]);

  return (
    <style>{`
      /* Effect 1: Ring-based with grayscale intensity */
      .ripple-effect-1 {
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple-effect-1 2s ease-out forwards;
        pointer-events: none;
        z-index: 9997;
      }

      @keyframes ripple-effect-1 {
        to {
          transform: scale(20);
          opacity: 0;
        }
      }

      /* Effect 2: White border with shadow */
      .ripple-effect-2 {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.25);
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
        transform: scale(0);
        opacity: 1;
        animation: ripple-effect-2 2s ease-out forwards;
        pointer-events: none;
        z-index: 9997;
        background: transparent;
      }

      @keyframes ripple-effect-2 {
        to {
          transform: scale(20);
          opacity: 0;
        }
      }

      /* Effect 3: Radial gradient */
      .ripple-effect-3 {
        position: absolute;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        transform: scale(0.1);
        opacity: 0.9;
        pointer-events: none;
        z-index: 9997;
        background: radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.4) 60%, rgba(255,255,255,0.1) 100%);
        animation: ripple-effect-3 1.6s ease-out forwards;
      }

      @keyframes ripple-effect-3 {
        to {
          transform: scale(1.8);
          opacity: 0;
        }
      }

      /* Effect 4: White border with glow */
      .ripple-effect-4 {
        position: absolute;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 3px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
        background: transparent;
        transform: scale(0.2);
        opacity: 1;
        pointer-events: none;
        z-index: 9997;
        animation: ripple-effect-4 1s ease-out forwards;
      }

      @keyframes ripple-effect-4 {
        to {
          transform: scale(3);
          opacity: 0;
        }
      }

      /* Effect 5: Wave-based grayscale */
      .ripple-effect-5 {
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple-effect-5 1.5s ease-out forwards;
        pointer-events: none;
        z-index: 9997;
      }

      @keyframes ripple-effect-5 {
        to {
          transform: scale(60);
          opacity: 0;
        }
      }

      /* Effect 6: Circular wave with offset */
      .ripple-effect-6 {
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple-effect-6 1.5s ease-out forwards;
        pointer-events: none;
        z-index: 9997;
      }

      @keyframes ripple-effect-6 {
        to {
          transform: scale(60);
          opacity: 0;
        }
      }

      /* Effect 7: Colorful pastel ripples */
      .ripple-effect-7 {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple-effect-7 1.2s ease-out forwards;
        pointer-events: none;
        z-index: 9997;
      }

      @keyframes ripple-effect-7 {
        to {
          transform: scale(60);
          opacity: 0;
        }
      }
    `}</style>
  );
} 